import { ActionIcon, Tooltip } from "@mantine/core";
import { spotlight } from "@mantine/spotlight";
import { type TablerIcon } from "@tabler/icons-react";
import { Link } from "react-router";

interface QuicklinkProps {
  label: string;
  to: string;
  Icon: TablerIcon;
}

function Quicklink({ label, to, Icon }: QuicklinkProps) {
  return (
    <Tooltip
      label={label}
      zIndex={10000} // more than spotlight overlay (9999)
    >
      <ActionIcon
        component={Link}
        td={"none"}
        to={to}
        variant="outline"
        onClick={() => {
          spotlight.close();
        }}
      >
        <Icon />
      </ActionIcon>
    </Tooltip>
  );
}
export { Quicklink };
